import { render, staticRenderFns } from "./healthCareDetail.vue?vue&type=template&id=65173703&scoped=true&"
import script from "./healthCareDetail.vue?vue&type=script&lang=js&"
export * from "./healthCareDetail.vue?vue&type=script&lang=js&"
import style0 from "./healthCareDetail.vue?vue&type=style&index=0&id=65173703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65173703",
  null
  
)

export default component.exports